DeviceManager.Internal.BarcodeScanner = {};